import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "cix-container" }
const _hoisted_2 = { class: "columns" }
const _hoisted_3 = { class: "column is-12" }
const _hoisted_4 = { class: "s-card" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = { class: "control" }
const _hoisted_7 = { class: "field" }
const _hoisted_8 = { class: "control" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "notification is-danger is-light mt-4"
}
const _hoisted_11 = {
  key: 1,
  class: "columns mt-4"
}
const _hoisted_12 = { class: "column is-12" }
const _hoisted_13 = { class: "s-card" }
const _hoisted_14 = { class: "table-container" }
const _hoisted_15 = { class: "table is-fullwidth is-hoverable" }
const _hoisted_16 = { class: "has-text-centered has-text-weight-bold" }
const _hoisted_17 = { class: "field mt-4" }
const _hoisted_18 = { class: "control" }
const _hoisted_19 = {
  key: 0,
  class: "tsv-preview mt-4"
}
const _hoisted_20 = { class: "tsv-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "title-wrap" }, [
      _createElementVNode("h1", { class: "title is-4 mb-4" }, "CIX Formula Parser")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("label", { class: "label" }, "Formula:", -1)),
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formula) = $event)),
                class: "textarea",
                placeholder: "Enter Bloomberg CIX formula...",
                rows: "4"
              }, null, 512), [
                [_vModelText, _ctx.formula]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                class: _normalizeClass(["button is-primary", { 'is-loading': _ctx.isLoading }]),
                disabled: !_ctx.formula.trim() || _ctx.isLoading,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.parseFormula && _ctx.parseFormula(...args)))
              }, " Clean Formula ", 10, _hoisted_9)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    (_ctx.parsedData.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("table", _hoisted_15, [
                  _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        class: "has-text-centered",
                        style: {"width":"60px"}
                      }),
                      _createElementVNode("th", null, "variable"),
                      _createElementVNode("th", null, "coefficient")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsedData, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_16, _toDisplayString(index), 1),
                        _createElementVNode("td", null, _toDisplayString(item.variable), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.formatCoefficient(item.coefficient)), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    class: "button is-info is-outlined",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.copyToClipboard && _ctx.copyToClipboard(...args)))
                  }, " Copy TSV to Clipboard ")
                ])
              ]),
              (_ctx.tsvData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "has-text-grey-light mb-2" }, "Tab-separated values (ready for Excel):", -1)),
                    _createElementVNode("pre", _hoisted_20, _toDisplayString(_ctx.tsvData), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}